import { http, SuccessResponseV1 } from './http'

//
// POST: /api/v1/login
//
export type PostLoginSuccessResponseV1 = SuccessResponseV1<{
  token: string
}>

export async function postLoginV1API(key: string, secret: string) {
  const {
    data: { data },
  } = await http.post<PostLoginSuccessResponseV1>(`/v1/login`, {
    key,
    secret,
  })
  return data
}
